var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.cssClass,attrs:{"href":_vm.url,"target":_vm.target,"title":_vm.title}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }